var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"would-you-like-to-block",style:({ 'background-image': `url(${_vm.data.image})` }),on:{"click":_vm.click}},[_c('h4',[_vm._v(_vm._s(_vm.data.title))]),_c('p',[_vm._v(_vm._s(_vm.data.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }